import { ApDialogRef } from './ApDialogConfig';

export const NormalModalResult = 'ApActiveModalResult' as const;

export class ApActiveModal<T> {
  constructor(
    private _close: (value: T | PromiseLike<T>) => void,
    private _dismiss: (reason?: any) => void,
  ) { }

  private _dialogRef: ApDialogRef;
  get dialogRef(): ApDialogRef {
    return this._dialogRef;
  }
  private beforeManualClose: () => void;

  private closedOrDismissed = false;
  private readyToHide = false;

  setup(
    dialogRef: ApDialogRef,
    beforeManualClose: () => void
  ) {
    this._dialogRef = dialogRef;
    this.beforeManualClose = beforeManualClose;
  }

  private onHide: () => void = () => {
    this._dismiss(undefined);
  };

  // close the modal with a specific return value
  emitAndClose(result: T | PromiseLike<T>): void {
    this.onHide = () => {
      this.closeModal();
      this._close(result);
    };
    this.closedOrDismissed = true;
    this.tryHide();
  }

  // dismiss the modal for a specific reason (should normally be Error)
  dismiss(reason?: any): void {
    this.onHide = () => {
      this.closeModal();
      this._dismiss(reason);
    };
    this.closedOrDismissed = true;
    this.tryHide();
  }

  // call when closing of modal is already done elsewhere
  emitWithoutClose(result: T | PromiseLike<T>): void {
    this.onHide = () => {
      this._close(result);
    };
    this.closedOrDismissed = true;
    this.tryHide();
  }

  // call when closing of modal is already done elsewhere
  dismissWithoutClose(reason?: any): void {
    this.onHide = () => {
      this._dismiss(reason);
    };
    this.closedOrDismissed = true;
    this.tryHide();
  }

  markReadyToHide(): void {
    this.readyToHide = true;
    this.tryHide();
  }

  // Don't hide the modal until it's ready to be hidden,
  // and there has been a call to close or dismiss it.
  private tryHide() {
    if (this.closedOrDismissed && this.readyToHide) {
      this.onHide();
    }
  }

  private closeModal() {
    this.beforeManualClose();
    this.dialogRef.close(NormalModalResult);
  }
}
